export enum LogicalOperatorEnum {
    and,
    or
}
